import { useTranslation } from "react-i18next";
import styles from "./Section.module.css";
import {
  Calendar,
  ChevronsLeftRightEllipsis,
  Globe,
  RadioTower,
  SquareGanttChart,
} from "lucide-react";
import { Tag } from "../../PresentationalComponents/Tag";

const sectionDictionary = {
  fa: {
    Project: "پروژه",
    LiveDemo: "دمو آنلاین",
    Language: "زبان",
    Date: "تاریخ",
    Technologies: "فناوری‌ها",
    InProgress: "در حال ساخت",
  },
  en: {
    Project: "Project",
    LiveDemo: "Live Demo",
    Language: "Language",
    Date: "Date",
    Technologies: "Technologies",
    InProgress: "IN PROGRESS",
  },
};

export function Section({ project }) {
  const { i18n } = useTranslation();
  const lang = i18n.language;

  return (
    <section className={styles.sectionContainer}>
      <div className={styles.mainTextBox}>
        <h3>{project[lang].header.title}</h3>

        {project[lang].header.description.map((p, paragraphIndex) => (
          <>
            <p key={paragraphIndex}>{p}</p>
            <br />
          </>
        ))}
      </div>
      <div className={styles.sideFeaturesContainer}>
        <div className={styles.featureContainer}>
          <SquareGanttChart className={styles.svg} />
          <label>{sectionDictionary[lang].Project} :</label>
          <p>{project[lang].side.Project}</p>
        </div>
        <div className={styles.featureContainer}>
          <RadioTower className={styles.svg} />
          <label>
            {sectionDictionary[lang].LiveDemo} :
            {project[lang].side.LiveDemo.length > 1 ? (
              <a href={project[lang].side.LiveDemo} target="_blank">
                {sectionDictionary[lang].LiveDemo}
              </a>
            ) : (
              <a>{sectionDictionary[lang].InProgress}</a>
            )}
          </label>
        </div>
        <div className={styles.featureContainer}>
          <Calendar className={styles.svg} />
          <label>{sectionDictionary[lang].Date} :</label>
          <p>{project[lang].side.Date}</p>
        </div>
        <div className={styles.featureContainer}>
          <Globe className={styles.svg} />
          <label>{sectionDictionary[lang].Language} :</label>
          <p>{project[lang].side.Language}</p>
        </div>
        <div className={styles.featureContainer}>
          <ChevronsLeftRightEllipsis className={styles.svg} />
          <label>
            {sectionDictionary[lang].Technologies} : <br />
          </label>
        </div>
        <div>
          {project[lang].side.Technologies.split(" · ").map((tag, index) => (
            <Tag text={tag} key={index} />
          ))}
        </div>
      </div>
    </section>
  );
}
